import styled, {ThemeProps} from 'styled-components';
import {textSizes} from '@stencil/build-theme/src/build-theme';
import {Assign} from 'utility-types';

// TYPES
import {Row} from '../../../../../stories/components/hotels/common/Layouts/Layouts';

// THEME
import {Theme} from '../../../../../stories/theme/types';

const RoomTextInfoWrapperStyled = styled(Row)((
  props: Assign<ThemeProps<Theme>, {spacedOutBy?: string}>,
) => {
  const padding = `${props.spacedOutBy ? props.spacedOutBy : 0} 0`;
  const width = `${props.width ? props.width : ''}`;
  const display = `${props.display ? props.display : ''}`;
  return `
    padding: ${padding};
    align-items: center;
    width:${width};
    display:${display};
  `;
});

const RoomInfoTextStyled = styled.span(
  (props: Assign<ThemeProps<Theme>, {color?: string}>) => `
  // padding: 0 ${props.theme.spacing.base};
  font-size: ${props.theme.font.custom(14)};
  color: ${props.color ? props.color : 'inherit'};
  display: flex;
  align-items: ${props.alignItems ? props.alignItems : 'baseline'};
`,
);

const RoomInfoText: React.FC<{
  children: React.ReactNode;
  textColor?: string;
  spacedOutBy?: string;
  alignItems?: string;
  width?: string;
  display?: string;
}> = ({children, textColor, spacedOutBy, alignItems, width, display}) => {
  return (
    <RoomTextInfoWrapperStyled spacedOutBy={spacedOutBy} width={width} display={display}>
      <RoomInfoTextStyled color={textColor} alignItems={alignItems}>
        {children}
      </RoomInfoTextStyled>
    </RoomTextInfoWrapperStyled>
  );
};
export default RoomInfoText;

// GO TRIBE
export const GoTribeTextInnerWrapper = styled.div`
  a {
    color: #2276e3;
    ${textSizes.SmallW3};
  }
  margin-bottom: 3px;
`;
export const headerWrapper = styled.div`
  display: flex;
`;
export const GoTribeTextWrapper = styled.div`
  display: flex;
`;
export const contentContainer = styled.div`
  padding-left: 1.2rem;
  // display: flex;
`;

export const MoreButtonWrapper = styled.span`
  ${textSizes.SmallW2};
  color: #2274e0;
  margin-left: 0.5rem;
`;

export const BenefitsItemContainer = styled.div``;

export const GTSSStarGradient = styled.div`
  background: linear-gradient(315deg, #f8cd46 0%, #f4a900 100%);
  width: 5px;
  height: 5px;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
  position: static;
  left: 0;
  top: 8px;
  margin-right: 5px;

  &.star {
    background: linear-gradient(315deg, #ff6d38 0%, #ff3a5c 100%);
  }
`;
export const goTribeIcon = styled.img`
  width: 80px;
`;
export const starIcon = styled.div`
  display: flex;
  align-items: center;
`;
export const Item = styled.p`
  width: auto;
`;
